module.exports = __webpack_public_path__ + "fonts/icons.faff9214.faff9214.woff";